module.exports = __webpack_public_path__ + "img/gcash-banner2.430fc448.png";